import { Flex } from "@chakra-ui/react";
import InputCard from "../../components/InputCard";
import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { set } from "../access-code-page/accessCodeReducer";
import { setIsCustom } from "../../isCustomReducer";
import API from "../../api-info";
import { AccessCode } from "../../models/access-code";

async function fetchAccessCode(
  accessCode: string
): Promise<AccessCode | undefined> {
  try {
    const response = await fetch(
      API.baseAddress + "getIsAccessCodeValid?accessCode=" + accessCode
    );
    if (response.ok) {
      const data = await response.json();
      return data as AccessCode;
    }
  } catch (error) {}

  return undefined;
}

function CustomAccessCodePage() {
  const dispatch = useDispatch();
  const { state: routingState } = useLocation();
  let code = routingState?.accessCode;
  const autoSubmit = routingState?.autoSubmit === true;

  const [isAccessCodeInvalid, setIsAccessCodeInvalid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const hasAutoSubmitted = useRef(false);

  const submitAccessCode = async (val: string) => {
    dispatch(set(val));
    setIsLoading(true);
    const accessCode = await fetchAccessCode(val);
    if (accessCode && accessCode.IsValid) {
      setIsAccessCodeInvalid(false);
      dispatch(setIsCustom(true));
      navigate("/test", {
        state: {
          accessCode: val,
          phase: accessCode.Phase,
          type: accessCode.Type,
          isCustom: true,
        },
      });
    } else {
      setIsAccessCodeInvalid(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (autoSubmit && code && !hasAutoSubmitted.current) {
      hasAutoSubmitted.current = true;
      submitAccessCode(code);
    }
  }, []);

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      mb="4rem"
      flexGrow={1}
    >
      <InputCard
        className="input-access-code"
        title="Start the Assessment"
        subTitle="Please enter the access code provided to you. This code will grant you access to the assessment and allow you to begin."
        placeholder="Access code"
        isLoading={isLoading}
        invalidMsg="Invalid access code. Please contact your administrator."
        invalidMsgShown={isAccessCodeInvalid}
        inputValue={code === undefined ? "" : code}
        onSubmit={submitAccessCode}
      />
    </Flex>
  );
}

export default CustomAccessCodePage;
